import { createFileRoute } from "@tanstack/react-router";

import BackButton from "@/components/back-button";
import { PrivacyContent } from "@/routes/app/$role/setup/-steps/legal-agreements";

export const Route = createFileRoute("/static/_layout/privacy")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="w-full px-4 md:px-12 lg:px-[140px] pb-[200px] flex flex-col gap-8">
      <BackButton />
      <div className="prose-legal max-w-[900px]">
        <PrivacyContent />
      </div>
    </div>
  );
}
